import Vue from 'vue'
import VueResource from 'vue-resource'
import Cookies from 'js-cookie'
const configDev = require('../../config/dev.env.js')
const configProd = require('../../config/prod.env.js')

Vue.use(VueResource)

// по усполчанию смотрим в куки и загружаем конфиг для стэйджа
let API_ROOT = Cookies.get('API_ROOT') ? Cookies.get('API_ROOT') : configDev.API_ROOT

if (process.env.NODE_ENV === 'production') {
  // если билд для прода то смотрим в куки или в конфиг для прода
  API_ROOT = Cookies.get('API_ROOT') ? Cookies.get('API_ROOT') : configProd.API_ROOT
}

const JSON_API_ROOT = API_ROOT + '/wp-json/wp/v2'

const apis = {
  loadCategories () {
    // let path = `${JSON_API_ROOT}/category?orderby=menu_order&order=asc&per_page=100`
    // if (Cookies.get('new_test')) {
    // }
    let path = 'https://menu.xochu-shashlik.ru/wp-content/themes/welbempty/mangalGrillSite.php'

    return Vue.http.get(path)
    // return Vue.http.get(`${JSON_API_ROOT}/category?orderby=menu_order&order=asc&per_page=100`)
  },
  loadRestaurants () {
    return Vue.http.get(`${JSON_API_ROOT}/restaurant?orderby=menu_order&order=asc&per_page=100`)
  },
  loadPromotions () {
    // let path = `${JSON_API_ROOT}/promotion?orderby=menu_order&order=asc&per_page=100`
    // if (Cookies.get('new_test')) {
    // }
    let path = API_ROOT + '/wp-content/themes/welbempty/promotions.php'
    return Vue.http.get(path)
    // return Vue.http.get(`${JSON_API_ROOT}/promotion?orderby=menu_order&order=asc&per_page=100`)
  },
  createOrder (payload) {
    // let path = `${API_ROOT}/wp-content/themes/welbempty/saveOrder.php`
    // if (Cookies.get('new_test')) {
    // }
    let path = 'https://menu.xochu-shashlik.ru/wp-content/themes/welbempty/createOrder.php'
    return Vue.http.post(path, payload)
    // return Vue.http.post(`${API_ROOT}/wp-content/themes/welbempty/saveOrder.php`, payload)
  },
  reserveTable (payload) {
    return Vue.http.post(`${API_ROOT}/wp-content/themes/welbempty/reserveTable.php`, payload)
  }
}
const api = apis
export {api}

// Доступ к апишкам для дев-режима
if (process.env.NODE_ENV === 'development') {
  window.apis = apis
}



// WEBPACK FOOTER //
// ./src/api/index.js